import React from "react";

interface Props {
  isLoading: boolean;
}
export const Loader = ({ isLoading }: Props) => {
  return <></>;
};
